import { useAuth0 } from "@auth0/auth0-react";
import { useGetUserProfileQuery } from "api/userProfiles/useGetUserProfile";

const useCurrentUserProfile = () => {
  const { user } = useAuth0();
  const { data: userProfile, isLoading, isError } = useGetUserProfileQuery(user?.sub || "");
  
  return {
    user,
    userProfile,
    isLoading,
    isError
  };
};

export default useCurrentUserProfile;